import { mapGetters, mapMutations } from 'vuex';
import { isNullOrUndefined } from 'util';
import { orderService } from '../../services/OrderService'

export default {
    name: 'SelectedOffer',

    components: {
    },

    props:
    {
    },

    data: () => {
        return {
            loading: true,
            selectedOffer: {},
        }
    },

    created() {

        this.getSelectedOffer();
    },

    computed: {
        ...mapGetters(
            {
                order: 'order/order',
                currentOrderOffer: 'order/currentOrderOffer',
            }),
    },

    methods: {
        //
        backButtonClick: function () {

        },

        getSelectedOffer: function () {

            this.selectedOffer = this.currentOrderOffer;
        },
        //
        getOfferTotal(offer) {

            if (offer == null)
                return 0;
            var total = offer.Price;
            if (offer.ExtraOffers != null) {
                offer.ExtraOffers.forEach(extraOffer => {
                    if (extraOffer.Selected) {
                        total += extraOffer.Value;
                    }
                });
            }

            console.log('getOfferTotal->' + total);
            return total;
        },

        transferDataClick: function () {
        },
        confirmTransfer: function () {
        },
        backClick: function () {

        },
        refreshOffers: function () {

            // remove the selected offer ??

            // refresh orders
            
        },
        getLogo: function (insurer) {
            return 'img/logos/' + insurer + '-logo.png';
        },

        
    },
}
